/*jshint esversion: 9 */
import GetConfirmation from '../components/UI/GetConfirmation/GetConfirmation';
import { createConfirmation } from 'react-confirm';

const confirm = createConfirmation(GetConfirmation);

export default function(confirmation, options = {}) {
  return confirm({ confirmation, ...options });
}